import { AppData, Img, Lightning, Log, Utils } from '@lightningjs/sdk'
import { textures } from '../../build/lib/lightning.es5'
import { Helper } from '../lib/helper'
import { ItemNode } from "../lib/components/grid/ItemNode"
import StarUI from './star-ui'
import { AppSetup } from '../lib/app-setup'
import { Theme } from './info-ui'
import { Badge, TextBox } from '@lightningjs/ui-components'
import FallbackImage from './fallback-image'

export interface ResumeInfoUITemplateSpec extends Lightning.Component.TemplateSpec {
  NodeImg: object
  ImageWrapper: object
  background: string
  item: ItemNode
}

export default class ResumeInfoUI
  extends Lightning.Component<ResumeInfoUITemplateSpec>
  implements Lightning.Component<ResumeInfoUITemplateSpec>
{
  _theme: Theme = {};
  NodeImg = this.getByRef('NodeImg')!
  ImageWrapper = this.getByRef('ImageWrapper')!
  private _focusAnimation: Lightning.types.Animation | undefined = undefined

  currentItem: ItemNode | null = null
  pendingLogoUrl: string | null = null

  static override _template(): Lightning.Component.Template<ResumeInfoUITemplateSpec> {
    return {
      ...super._template(),
      NodeImg: {
        w: 1920,
        h: 1080,
        x: 1920,
        y: 0,
        mountX: 1,
        src: '',
      },
      ImageWrapper: {
        x: 0,
        y: 0,
        w: 1920,
        h: 1080,
        rect: true,
        //colorTop: 0xff000000,
        //colorBottom: 0xff00000,
        colorLeft: 0xff0e0e1e,
        colorRight: 0x9f0e0e1e,
      },
      InfoTextWrapper: {
        x: 152,
        y: 55,
        flex: { direction: 'column'},
        SeriesTitle: { text: { text: '', fontSize: 38, fontFace: Helper.getFontFamily('Regular') } },
        Title: { text: { text: '', fontSize: 50, fontFace: Helper.getFontFamily('Black'), wordWrapWidth: 1500, textOverflow: "ellipsis", wordWrap:false} },
        ContentLogo: { visible: false,
          flexItem: {
              // marginTop: 5,
              marginBottom: 20
          }
         },
        ItemMetadataWrapper: {
          flexItem:{ marginTop: 0 },
          flex: { direction: 'row', alignItems: 'center', wrap: false },
          rect: true, color: 0x00000000,
          children: []
        },
        Description: {
          flex: {},
          x: 0,
          Text: {
            w: 1700,
            autoResizeHeight: true,
            type: TextBox,
            fixed: true,
            content: '',
            contentWrap: true,
            style: {
              textStyle: {
                maxLines: 7,
                maxLinesSuffix: '...',
                fontSize: 24,
                fontFace: Helper.getFontFamily('Regular'),
                wordWrapWidth: 1000
              }
            }
          }
        },
        Actors: { flexItem:{ marginTop: 20 }, alpha: 0, x: 0, text: { text: 'ACTORS', textColor: 0xffffffff, fontSize: 24, fontFace: Helper.getFontFamily('Regular'), letterSpacing : 1.5, wordWrapWidth: 1000, maxLines: 2, textOverflow: 'ellipsis' } },
        Directors: { flexItem:{ marginTop: 20 }, alpha: 0, x: 0, text: { text: 'DIRECTORS', textColor: 0xffffffff, fontSize: 24, fontFace: Helper.getFontFamily('Regular'),letterSpacing : 1.5, wordWrapWidth: 1000, maxLines: 2, textOverflow: 'ellipsis'  } },
        MoodsTag: { flexItem:{ marginTop: 20 },  x: 0, text: { text: '', fontSize: 24, fontFace: Helper.getFontFamily('Light',), textColor: 0x80ffffff}},
      },
    }
  }


  override _init() {
    const image = this.tag('NodeImg')
    image?.on('txLoaded', () => {
      image.setSmooth('alpha', 1)
    })
    const { appState } = AppData as AppSetup
    const app = appState?.getApp();
    this._theme = (app?.themesObj as Theme) || {};
    const appApiConfig = appState?.getAppApiConfig()
    this._theme.ageRatingColor= `0xff${appApiConfig?.appConfig?.ageRatingColor}` || '0xffffffff'

     this.tag('InfoTextWrapper.ContentLogo').on('txError', this._onContentLogoError.bind(this))
  }

  /* Fallback: if the ContentLogo image errors (e.g. 404), show the text Title instead */
  _onContentLogoError() {
    if (!this.pendingLogoUrl || !this.currentItem) return
    const item = this.currentItem
    Log.error('ContentLogo failed to load, falling back to title:', this.pendingLogoUrl)
    this.pendingLogoUrl = null
    this.patch({
      InfoTextWrapper: {
        Title: { visible: true, text: { text: item.title } },
        ContentLogo: { visible: false },
      },
    })
  }

  set background(url: string) {
    /*this.patch({
      ImageWrapper: {
        texture: Img(url).contain(1920, 1080),
      },
    })*/
  }

  isDisplayActAndDir=false;
  set displayActAndDir(display: any) {
    this.isDisplayActAndDir = display
  }

  getPatchObjects(item: ItemNode): any {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    const bgcolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.bgcolor)
    const textcolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textcolor, 0.5)
    const likeImg = appApiConfig?.appConfig.likeImg;
    const dislikeImg = appApiConfig?.appConfig.dislikeImg;
    const loveitImg = appApiConfig?.appConfig.loveitImg
    const infoObj: any = {
      SeriesTitle: { text: { text: item.series_name || '' } },
      ItemMetadataWrapper: {
        children: [],
        visible:false
      },
      Actors: {
        alpha: 0,
        text: { text: ''},
        visible:false
      },
      Directors: {
        alpha: 0,
        text: { text: ''},
        visible:false
      },
      Description: {
        Text: { content: Helper.getLocalizedDescription(item) },
      },
      MoodsTag: { text: { text: item.mood_tags ? item.mood_tags.split(',').join('  •  ') : ''}}
    }

    this.currentItem = item
    const contentLogoImg = item.content_logo
    if (appApiConfig?.appConfig?.enableContentLogo && contentLogoImg) {
      this.pendingLogoUrl = contentLogoImg
      infoObj.Title = { visible: false }
      infoObj.ContentLogo = {
        visible: true,
        texture: {
          src: contentLogoImg,
          type: Lightning.textures.ImageTexture,
          resizeMode: { type: 'contain', h: 70 }
        },
      }
    } else {
      this.pendingLogoUrl = null
      infoObj.Title = { visible: true, text: { text: item.title } }
      infoObj.ContentLogo = { visible: false }
    }

    const releaseDate = item.release_date
    const airingPeriodAlpha = (item.airing_period == null || item.airing_period === '' ? 0 : 1)
    const runtimeAlpha = (item.runtime == 0 || airingPeriodAlpha == 1 ? 0 : 1)
    const ageRatingAlpha = (item.age_appropriate_rating == '' ? 0 : 1)
    const popularityRatingAlpha = (item.popularity_rating == -1 ? 0 : 1)
    const actorsAlpha = (item.actors == null ? 0 : 1)
    const directorsAlpha = (item.directors == null ? 0 : 1)
    const likeDisLikeAlpha = (item.likedislike == null ? 0 : Number(item.likedislike))
    const releaseDateRuntime = [
      releaseDate !== '' ? releaseDate : null,
      runtimeAlpha == 1 ? Helper.secondsToHms(item.runtime!) : null,
    ].filter((v): v is string => v !== null).join(' • ')
    let metavisible = false;
    if (releaseDateRuntime !== '' || airingPeriodAlpha == 1 || ageRatingAlpha == 1 || popularityRatingAlpha == 1 || likeDisLikeAlpha !== 0) {
      metavisible = true;
    }
    infoObj.ItemMetadataWrapper = {
      children: [],
      visible: metavisible
    }
    if (releaseDateRuntime !== '' && airingPeriodAlpha == 0) {
      infoObj.ItemMetadataWrapper.children.push({
          h: 50,
          y: 8,
          flexItem: { marginLeft: 0, marginRight: 35 },
          text: { alpha:0.5, text: releaseDateRuntime, fontSize: 24, fontFace: Helper.getFontFamily('Light'), textColor: Helper.getHexaColor("ffffff", 0.5), },
      })
    }
    if (airingPeriodAlpha == 1) {
      infoObj.ItemMetadataWrapper.children.push({
        h: 50,
        y: 6,
        flexItem: { marginRight: 35 },
        text: { text: item.airing_period, fontSize: 24, fontFace: Helper.getFontFamily('Light'), textColor: Helper.getHexaColor("ffffff", 0.5) },
      })
    }
    if (ageRatingAlpha == 1) {
      infoObj.ItemMetadataWrapper.children.push({
        // h: 50,
        flexItem: { marginLeft: 0, marginRight: 35 },
        type: Badge,
        title: item.age_appropriate_rating, style: { paddingX: 16, paddingY: 3, strokeWidth: 0, backgroundColor: textcolor, radius: 0, textStyle: { fontSize: 20, textColor: bgcolor, fontFace: Helper.getFontFamily('Regular') } }
      })
    }

    const ccIcon = Helper.getCCIcon(item);
    if (ccIcon !== '') {
      infoObj.ItemMetadataWrapper.children.push({
        flexItem: { marginLeft: 0, marginRight: 35 },
        color: Helper.getHexaColor("ffffff", 0.5),
        texture: {
          src: Utils.asset(ccIcon),
          type: Lightning.textures.ImageTexture
        }
      })
    }

    const isMultiLangEnabled = Helper.hasSupportedMultiLangDescription(item);

    if (isMultiLangEnabled) {
        infoObj.ItemMetadataWrapper.children.push({
            flexItem: { marginLeft: 0, marginRight: 35 },
            color: Helper.getHexaColor("ffffff", 0.5),
            texture: {
                src: Utils.asset('images/ico-multi-lang.png'),
                type: Lightning.textures.ImageTexture
            }
        })
    }


    if (likeDisLikeAlpha !== 0) {
      let icon = '';
      let isApiIcon = false;
      if (likeDisLikeAlpha == 1) {
        icon = 'images/ico-thumbsup.png';
        // isApiIcon = !!likeImg;
      }
      else if (likeDisLikeAlpha == 2) {
        icon = 'images/ico-love.png';
        // isApiIcon = !!loveitImg;
      }
      else if (likeDisLikeAlpha == 3) {
        icon = 'images/ico-thumbsdown.png';
        // isApiIcon = !!dislikeImg;
      }

      if (icon !== '') {
        infoObj.ItemMetadataWrapper.children.push({
          w: 36, h: 36,
          flexItem: { marginLeft: 0, marginRight: 35 },
          color: Helper.getHexaColor("ffffff", 0.5),
          alpha: 0.5,
          type: FallbackImage,
          imgSrc: icon,
        })
      }
    }

    if (popularityRatingAlpha == 1) {
      infoObj.ItemMetadataWrapper.children.push({
        // h: 40,
        alpha: popularityRatingAlpha,
        type: StarUI,
        rating: item.popularity_rating,
      })
    }
    if(this.isDisplayActAndDir){
      let actorsVisible = false;
      let directorsVisible = false;
      if (actorsAlpha == 1) {
        actorsVisible = true;
      }
      if (directorsAlpha == 1) {
        directorsVisible = true;
      }
      if (actorsAlpha == 1) {
        infoObj.Actors = {
          alpha: actorsAlpha,
          text: { text: 'Cast: ' + item.actors, fontSize: 24, fontFace: Helper.getFontFamily('Regular') },
          visible: actorsVisible
        }
      }
      if (directorsAlpha == 1) {
        infoObj.Directors = {
          alpha: directorsAlpha,
          text: { text: 'Direction: ' + item.directors, fontSize: 24, fontFace: Helper.getFontFamily('Regular') },
          visible: directorsVisible
        }
      }
    }

    return infoObj
  }

  set item(item: ItemNode) {
    if (!item) return;
    this.patch({
      InfoTextWrapper: this.getPatchObjects(item),
      NodeImg: {
        src: item.bg_image_landscape,
      },
    })
  }

  override _firstActive() {
    //this._update()
  }

  override _focus() {
    if (this._focusAnimation) {
      this._focusAnimation.start()
    }
  }

  override _unfocus() {
    this._focusAnimation?.stop()
  }

  static get width() {
    return 400
  }

  static get height() {
    return 600
  }

  // _handleClick(target) {
  //   this.fireAncestors('$handleClick', target)
  // }
}
